import { motion } from 'framer-motion';
import { Box } from './Box.js';

var AnimatedBox = motion(Box);

export { AnimatedBox };
//# sourceMappingURL=AnimatedBox.js.map
